import { useQuery } from "@tanstack/react-query";
import Table from "../../ChildComponents/Table";
import { MdEditDocument } from "react-icons/md";

import useAuthToken from "../../Hooks/useAuthToken";
import { apiRequest } from "../../store/api/api";

function WebAdsList({ onEdit }) {
  const token = useAuthToken();
  const {
    data: adsList,
    isLoading: isAdsLoading,
    error: topicError,
  } = useQuery({
    queryKey: ["web-ads"],
    queryFn: () => apiRequest("get", "/api/web-ads", null, token),
  });

  const data = adsList?.data
    ?.map((e, index) => ({
      index: index + 1,
      secId: e?.sectionID,
      image: (
        <img
          className="img-fluid shadow rounded"
          width={"150px"}
          src={e.image}
          alt={e?.title}
        />
      ),
      status: e?.fontStatus ? "Active" : "InActive",
      actionButton: (
        <>
          <button onClick={() => onEdit(e)} className="btn text-success mx-2">
            <MdEditDocument />
          </button>
        </>
      ),
    }))
    .reverse();

  const columns = [
    {
      header: "SL#",
      accessor: "index",
    },
    {
      header: "Sec ID",
      accessor: "secId",
    },
    {
      header: "Image",
      accessor: "image",
    },
    {
      header: "Status",
      accessor: "status",
    },
    {
      header: "Actions",
      accessor: "actionButton",
    },
  ];
  return (
    <div>
      <Table columns={columns} data={data} isLoading={isAdsLoading} />
    </div>
  );
}

export default WebAdsList;
